import { render, staticRenderFns } from "./PersonalesPrecalificacionScotia.vue?vue&type=template&id=5c22163a&"
import script from "./PersonalesPrecalificacionScotia.vue?vue&type=script&lang=js&"
export * from "./PersonalesPrecalificacionScotia.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesPrecalificacionScotia.vue?vue&type=style&index=0&id=5c22163a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports